import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./index.css";

const GiftCertificates = () => {
  const [activeTab, setActiveTab] = useState("purchase");
  const [formData, setFormData] = useState({
    recipientName: "",
    recipientEmail: "",
    senderName: "",
    senderEmail: "",
    theme: "general",
    message: "",
    amount: "50",
    customAmount: "",
    agree: false,
  });
  const [redeemCode, setRedeemCode] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handlePurchaseSubmit = (e) => {
    e.preventDefault();
    if (!formData.agree) {
      alert("You must agree that gift certificates are non-refundable.");
      return;
    }
    const finalAmount = formData.amount === "custom" ? formData.customAmount : formData.amount;
    setSuccessMsg(`Success! A gift certificate of $${finalAmount} has been generated for ${formData.recipientName}. (Demo Only)`);
    setFormData({ recipientName: "", recipientEmail: "", senderName: "", senderEmail: "", theme: "general", message: "", amount: "50", customAmount: "", agree: false });
  };

  const handleRedeemSubmit = (e) => {
    e.preventDefault();
    if (!redeemCode.trim()) { alert("Please enter a valid gift certificate code."); return; }
    setSuccessMsg(`Certificate code "${redeemCode}" validated. $50.00 has been credited to your account! (Demo Only)`);
    setRedeemCode("");
  };

  return (
    <div>
      <CartBannerComponent title="Gift Certificates" />
      <div className="container gift-cert-container my-5">
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="gift-info-card p-4 shadow-sm h-100">
              <h4 className="font-weight-bold mb-3 text-primary">Why Send a Gift?</h4>
              <p className="text-muted">
                Give the gift of choice! A MadeInBangladesh.info gift certificate is the perfect present for any occasion.
              </p>
              <hr />
              <h5 className="font-weight-bold text-dark mt-4">How It Works:</h5>
              <ol className="work-list pl-3 text-muted">
                <li>Fill out the gift certificate details.</li>
                <li>Preview and purchase securely.</li>
                <li>The certificate code is emailed directly to the recipient.</li>
                <li>They redeem and enjoy shopping!</li>
              </ol>
              <div className="gift-preview-visual mt-4 text-center">
                <div className={`visual-voucher theme-${formData.theme}`}>
                  <div className="voucher-title text-uppercase font-weight-bold">Gift Certificate</div>
                  <div className="voucher-amount">
                    ${formData.amount === "custom" ? formData.customAmount || "0" : formData.amount}
                  </div>
                  <div className="voucher-to">To: {formData.recipientName || "Recipient"}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="gift-main-content p-4 shadow-sm rounded bg-white">
              <div className="tabs-wrapper mb-4 border-bottom d-flex">
                <button className={`tab-btn mr-3 pb-2 font-weight-bold text-uppercase ${activeTab === "purchase" ? "active" : ""}`} onClick={() => { setActiveTab("purchase"); setSuccessMsg(""); }}>
                  Purchase Certificate
                </button>
                <button className={`tab-btn pb-2 font-weight-bold text-uppercase ${activeTab === "redeem" ? "active" : ""}`} onClick={() => { setActiveTab("redeem"); setSuccessMsg(""); }}>
                  Redeem Certificate
                </button>
              </div>

              {successMsg && (
                <div className="alert alert-success alert-dismissible fade show">
                  <strong>Success!</strong> {successMsg}
                  <button type="button" className="close" onClick={() => setSuccessMsg("")}>
                    <span>&times;</span>
                  </button>
                </div>
              )}

              {activeTab === "purchase" ? (
                <form onSubmit={handlePurchaseSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Recipient's Name <span className="text-danger">*</span></label>
                      <input type="text" name="recipientName" className="form-control" required value={formData.recipientName} onChange={handleChange} placeholder="John Doe" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Recipient's Email <span className="text-danger">*</span></label>
                      <input type="email" name="recipientEmail" className="form-control" required value={formData.recipientEmail} onChange={handleChange} placeholder="recipient@example.com" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Your Name <span className="text-danger">*</span></label>
                      <input type="text" name="senderName" className="form-control" required value={formData.senderName} onChange={handleChange} placeholder="Jane Doe" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold">Your Email <span className="text-danger">*</span></label>
                      <input type="email" name="senderEmail" className="form-control" required value={formData.senderEmail} onChange={handleChange} placeholder="sender@example.com" />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="font-weight-bold">Voucher Theme <span className="text-danger">*</span></label>
                    <div className="d-flex flex-wrap theme-selection">
                      {["general", "birthday", "anniversary", "holiday"].map(theme => (
                        <label key={theme} className="theme-option mr-3">
                          <input type="radio" name="theme" value={theme} checked={formData.theme === theme} onChange={handleChange} className="mr-1" />
                          {theme.charAt(0).toUpperCase() + theme.slice(1)}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="font-weight-bold">Amount <span className="text-danger">*</span></label>
                    <div className="d-flex align-items-center mb-2">
                      <select name="amount" className="form-control w-50" value={formData.amount} onChange={handleChange}>
                        <option value="10">$10.00</option>
                        <option value="25">$25.00</option>
                        <option value="50">$50.00</option>
                        <option value="100">$100.00</option>
                        <option value="250">$250.00</option>
                        <option value="custom">Custom Amount</option>
                      </select>
                      {formData.amount === "custom" && (
                        <input type="number" name="customAmount" className="form-control w-50 ml-3" placeholder="Min $1.00" min="1" required value={formData.customAmount} onChange={handleChange} />
                      )}
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="font-weight-bold">Personal Message (Optional)</label>
                    <textarea name="message" className="form-control" rows="4" value={formData.message} onChange={handleChange} placeholder="Enter your message to the recipient..." />
                  </div>
                  <div className="mb-4 form-check">
                    <input type="checkbox" name="agree" className="form-check-input" id="agreeCheck" checked={formData.agree} onChange={handleChange} required />
                    <label className="form-check-label text-muted small" htmlFor="agreeCheck">
                      I understand that gift certificates are non-refundable and cannot be exchanged for physical cash.
                    </label>
                  </div>
                  <button type="submit" className="btn btn-primary px-5 py-2 text-uppercase">Add Gift Certificate to Cart</button>
                </form>
              ) : (
                <form onSubmit={handleRedeemSubmit} className="py-4">
                  <div className="mb-4">
                    <label className="font-weight-bold fs-5 mb-2">Enter Gift Certificate Code</label>
                    <p className="text-muted small">Enter your voucher code below to credit the balance to your shopping wallet.</p>
                    <input type="text" className="form-control form-control-lg code-input font-weight-bold text-center text-uppercase" placeholder="e.g. MIB-12345-XYZ" value={redeemCode} onChange={(e) => setRedeemCode(e.target.value)} />
                  </div>
                  <button type="submit" className="btn btn-primary px-5 py-2 text-uppercase">Apply Gift Certificate</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCertificates;